import { render, staticRenderFns } from "./StaticQuizList.vue?vue&type=template&id=57002f34&scoped=true"
import script from "./StaticQuizList.vue?vue&type=script&lang=js"
export * from "./StaticQuizList.vue?vue&type=script&lang=js"
import style0 from "./StaticQuizList.vue?vue&type=style&index=0&id=57002f34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57002f34",
  null
  
)

export default component.exports